import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'hotjar_config-initialized-action_unknown';
/**
 * Hotjar recording was successfully initialized.
 */
export function trackHotjarConfigInitialized() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
